import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_PEDIDO.BUSCAR_ITENS](context, { filtro, paginacao, idPedido }) {
		const { data } = await api.itemPedido.buscarItens(filtro, paginacao, idPedido)
		return data
	},
	async [actionTypes.ITEM_PEDIDO.BUSCAR_ITENS_DISPONIVEIS](context, { filtro, paginacao, idPedido }) {
		const { data } = await api.itemPedido.buscarItensDisponiveis(filtro, paginacao, idPedido)
		return data
	},
	async [actionTypes.ITEM_PEDIDO.SALVAR_ITEM_DISPONIVEL_QUANTIDADE](
		{ commit },
		salvarItemDisponivelQuantidadePedidoInput,
	) {
		commit(mutationTypes.COMUM.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
		const { data } = await api.itemPedido.salvarItemDisponivelQuantidade(salvarItemDisponivelQuantidadePedidoInput)
		commit(mutationTypes.COMUM.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
		return data
	},
	async [actionTypes.ITEM_PEDIDO.SALVAR_ITEM_QUANTIDADE](context, salvarItemQuantidadePedidoInput) {
		const { data } = await api.itemPedido.salvarItemQuantidade(salvarItemQuantidadePedidoInput)
		return data
	},
	async [actionTypes.ITEM_PEDIDO.EXCLUIR_ITEM](context, deletarItemPedidoInput) {
		const { data } = await api.itemPedido.deletarItem(deletarItemPedidoInput)
		return data
	},
	async [actionTypes.ITEM_PEDIDO.BUSCAR_ELEMENTOS_SUBELEMENTOS_ITEM](context, idItemPedido) {
		const { data } = await api.itemPedido.buscarElementosSubelementosItem(idItemPedido)
		return data
	},
	async [actionTypes.ITEM_PEDIDO.ALTERAR_ELEMENTO_SUBELEMENTO_ITEM](
		context,
		{ idItemPedido, idElementoSubelemento },
	) {
		const { data } = await api.itemPedido.alterarElementoSubelementoItem(idItemPedido, { idElementoSubelemento })
		return data
	},
}
